import { Routes } from "@angular/router";
import { Home } from "@components/pages/home/home";

export const routes: Routes=[
	{path: '', pathMatch: 'full', redirectTo: 'home', data: {name: 'welcome'}},
	{path: 'home', component: Home, data: {name: 'home'}}
];